import script from "./PreSettlementFundingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSettlementFundingPage.vue?vue&type=script&setup=true&lang=js"

import "./PreSettlementFundingPage.vue?vue&type=style&index=0&id=4bfb8d75&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bfb8d75"]])

export default __exports__